export default __webpack_public_path__ + "static/media/fad-punch-out.ed778060.svg";